import { Directionality, DIR_DOCUMENT } from '@angular/cdk/bidi';
import { Component, Inject, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatPaginator } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { TranslateService } from '@ngx-translate/core';
import { LocalStorageService } from 'ngx-webstorage';
import { Globle } from 'src/assets/globle';

import { Customer } from '../customer.model';
import { MandoobService } from '../mandoobs/mandoob.service';
import { OptionService } from '../option.service';
import { UsersService } from '../users/users.service';
import { FeescategoryserviceService } from 'src/app/e-fawateercom/feescategory/feescategoryservice.service';
import { QrfeescategoryService } from 'src/app/systemsettings/qrfeescategory/qrfeescategory.service';
import { Mandoob } from '../mandoobs/mandoob.model';

@Component({
  selector: 'app-Customers',
  templateUrl: './Customers.component.html',
  styleUrls: ['./Customers.component.css'],
  queries: {
    contentRef: new ViewChild("Modal"),
    contentRef1: new ViewChild("editModal"),
    contentRef2: new ViewChild("ModalLogOut"),
    contentRef3: new ViewChild("ModalConfirmApprove"),
  },
})
export class CustomersComponent implements OnInit {

  customers: Customer[] = [];
  customersFilter: Customer[] = [];
  displayedColumns: string[] = [];
  dataSource!: MatTableDataSource<Customer>;
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;
  spinnerOverlay = false
  public contentRef!: TemplateRef<any>;
  public contentRef1!: TemplateRef<any>;
  public contentRef2!: TemplateRef<any>;
  public contentRef3!: TemplateRef<any>;
  category: Customer = {} as Customer;
  customersStatus: { id: number, name: string }[] = [];
  userCategory: { id: number, name: string }[] = [];
  mandoobs: { id: number, name: string }[] = [];
  selectedStatus: number = 1;
  userId: string = "";
  pageSize = 100;
  userLoginId: string = "";

  editName!: string;
  editAddress!: string;
  editEmail!: string;
  EFfeesCategories: any;
  QRfeesCategories: any;

  otpCounter: any;
  counterEnd: boolean = false;
  otpConfirm = "";

  constructor(private service: OptionService,
    private userService: UsersService,
    private globle: Globle,
    private snackBar: MatSnackBar,
    private translateService: TranslateService,
    private dialog: MatDialog,
    private localStorage: LocalStorageService,
    private mandoobService: MandoobService,
    private feesCategoryService: FeescategoryserviceService,
    private qrFeesCategoryService: QrfeescategoryService
  ) {

  }

  ngOnInit() {
    this.userLoginId = this.localStorage.retrieve("userInfo").userId
    this.customersStatus = [{ id: 1, name: "active" },
    { id: 0, name: "notActive" }];

    this.displayedColumns = ['editInfo', 'name', 'mobile', 'email', "userCategoryId", "mandoobId",
      "feesCategoryId", "qrfeesCategoryId", "action"];

    this.selectedStatus = 1;
    this.pageSize = this.globle.pageSize;
    this.getUserCategory();
    this.getCustomers();
    this.getManddobs();
    this.getEFFeesCategories();
    this.getQRFeesCategories();
  }

  getCustomers() {
    this.spinnerOverlay = true;
    let userId = this.localStorage.retrieve("userInfo").userId
    this.service.getAllCustomers(userId).subscribe(data => {
      this.customers = data;

      this.customersFilter = this.customers.filter(x => x.status == this.selectedStatus);
      this.dataSource = new MatTableDataSource(this.customersFilter);
      this.dataSource.paginator = this.paginator;
      this.dataSource.sort = this.sort;
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  getUserCategory() {
    this.service.getUserCategory().subscribe(data => {
      this.userCategory = data;
    }, error => {
      console.log(error)
    })
  }

  getManddobs() {
    this.mandoobService.getAll().subscribe(data => {
      this.mandoobs = data
      console.log(this.mandoobs)
      // var mandoob = {} as Mandoob;
      // mandoob.id = 0;
      // mandoob.name = "لا يوجد";
      // this.mandoobs.unshift(mandoob);
    }, error => {
      console.log(error)
    })
  }

  getEFFeesCategories() {
    this.feesCategoryService.getAllCategory().subscribe(data => {
      this.EFfeesCategories = data;
    })
  }

  getQRFeesCategories() {
    this.qrFeesCategoryService.getAllCategory().subscribe(data => {
      this.QRfeesCategories = data;
    })
  }

  applyFilter(event: Event) {
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if (this.dataSource.paginator) {
      this.dataSource.paginator.firstPage();
    }
  }

  onDelete(id: string) {
    this.userId = id;
    this.openDialog();
  }

  openSnackBar(message: string, cssclass: string) {
    this.snackBar.open(message, 'Close', {
      duration: 6000,
      horizontalPosition: 'end',
      verticalPosition: 'top',
      panelClass: cssclass
    });
  }

  openDialog(): void {
    const dialogRef = this.dialog.open(this.contentRef, {
      width: '300px',
    });
  }

  openDialogEdit(): void {
    const dialogRef = this.dialog.open(this.contentRef1, {
      width: '300px',
    });
  }

  openDialogLogoutAll(): void {
    const dialogRef = this.dialog.open(this.contentRef2, {
      width: '300px',
    });
  }

  onNoClick(): void {
    this.userId = "";
    this.dialog.closeAll();
  }

  selectChange() {

    this.customersFilter = this.customers.filter(x => x.status == this.selectedStatus);

    // this.selectedStatus == 0 ? this.displayedColumns = ['name', 'mobile', 'email', "userCategoryId", "mandoobId", "approve", "delete"]
    //   : this.displayedColumns = ['name', 'mobile', 'email', "userCategoryId", "mandoobId", "edit", "delete"]
    this.dataSource = new MatTableDataSource(this.customersFilter);
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  update(userData: any) {

    this.spinnerOverlay = true;
    // var obj = {
    //   id:userData.id,
    //   usercategoryid:userData.userCategoryId,
    //   mandoobId:userData.mandoobId,
    //   efFeesCategoryId:userData.
    // }

    this.service.updateUserCategory(userData).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  approve(userData: any) {
    this.spinnerOverlay = true;
    this.service.approvedUser(userData.id, userData.userCategoryId, userData.mandoobId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("approvedSuccessfully"), 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();
    },
      error => {
        console.log(error);
        this.spinnerOverlay = false;
        this.openSnackBar(error.error.message, 'snackBarError');
      })
  }

  delete() {
    this.spinnerOverlay = true;
    this.dialog.closeAll();
    this.service.deleteUser(this.userId).subscribe(data => {
      this.openSnackBar(this.translateService.instant("deletedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  onDeactivate(id: string, _status: number) {
    this.userId = id;

    if (_status == 0) {

      var obj1 = {
        userId: this.userLoginId
      }

      this.service.send2FAToken(obj1).subscribe();
      this.otpCounter = "";
      this.timer(1);
      this.openDialogConfirmToken();
    }
    else {

      var obj = {
        userLoginId: this.userLoginId,
        userId: id,
        status: 0
      }

      this.activateAndDeActivateUser(obj);
    }
  }

  activateAndDeActivateUser(obj: any) {
    this.spinnerOverlay = true;

    this.service.ChangeUserStatus(obj).subscribe(data => {
      this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
      this.getCustomers();
    }, error => {
      console.log(error);
      this.spinnerOverlay = false;
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  // onDeactivate(id: string, _status: number) {

  //   var obj = {
  //     userId: id,
  //     status: _status == 1 ? 0 : 1
  //   }

  //   this.spinnerOverlay = true;

  //   this.service.ChangeUserStatus(obj).subscribe(data => {
  //     this.openSnackBar(this.translateService.instant("updatedSuccessfully"), 'snackBarSuccess');
  //     this.getCustomers();
  //   }, error => {
  //     console.log(error);
  //     this.spinnerOverlay = false;
  //     this.openSnackBar(error.error.message, 'snackBarError');
  //   })

  // }

  confirmActivatUser() {
    var obj = {
      userLoginId: this.userLoginId,
      userId: this.userId,
      status: 1,
      confirmToken: this.otpConfirm
    }
    this.dialog.closeAll();
    this.activateAndDeActivateUser(obj);
  }

  resendOTP() {
    var obj1 = {
      userId: this.userLoginId
    }
    this.service.send2FAToken(obj1).subscribe();
    this.timer(1);

  }

  edit(data: any) {
    this.editName = data['fullName'];
    this.editEmail = data['email'];
    this.editAddress = data['address'];
    this.userId = data['id'];

    this.openDialogEdit();
  }

  updateUserInfo() {
    this.spinnerOverlay = true;
    var obj = {
      id: this.userId,
      fullName: this.editName,
      address: this.editAddress,
      email: this.editEmail
    }
    this.userService.Update(obj).subscribe(data => {
      this.dialog.closeAll();
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  onChangeTransferBallance(id: string) {
    this.spinnerOverlay = true;
    this.userService.UpdateUserTransferBallance(id).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
      this.openSnackBar(error.error.message, 'snackBarError');
    })

  }

  onChangeQrCodeActive(id: string) {
    this.spinnerOverlay = true;
    this.userService.UpdateUserQrCodeTransActive(id).subscribe(data => {
      this.openSnackBar("تم التعديل بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
      this.getCustomers();

    }, error => {
      this.spinnerOverlay = false;
      console.log(error)
      this.openSnackBar(error.error.message, 'snackBarError');
    })
  }

  onLogOutFromAll(id: string) {
    this.openDialogLogoutAll();
    this.userId = id;
  }

  logOutFromAll() {
    this.dialog.closeAll();
    this.spinnerOverlay = true;
    this.userService.logOutFromAll(this.userId).subscribe(data => {
      this.openSnackBar("تم تسجيل الخروج من جميع الاجهزة بنجاح", 'snackBarSuccess');
      this.spinnerOverlay = false;
    },
      error => {
        this.spinnerOverlay = false;
        console.log(error);
      })
  }

  openDialogConfirmToken(): void {
    const dialogRef = this.dialog.open(this.contentRef3, {
      width: '350px',
    });
  }

  timer(minute: any) {
    // let minute = 1;
    let seconds: number = minute * 60;
    let textSec: any = "0";
    let statSec: number = 60;
    this.counterEnd = false;
    const prefix = minute < 10 ? "0" : "";

    const timer = setInterval(() => {
      seconds--;
      if (statSec != 0) statSec--;
      else statSec = 59;

      if (statSec < 10) {
        textSec = "0" + statSec;
      } else textSec = statSec;

      this.otpCounter = `${prefix}${Math.floor(seconds / 60)}:${textSec}`;

      if (seconds == 0) {
        this.counterEnd = true;
        clearInterval(timer);
      }
    }, 1000);
  }


}
